export default __webpack_public_path__ + "static/media/librarySS.6f2f3542.png";